import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 8;
const DEFAULT_HEIGHT = 8;

function IconStory({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 8 8">
            <path d="M7 0H1a.5.5 0 0 0-.5.5v7l.007.083a.5.5 0 0 0 .822.293L4 5.54l2.67 2.336A.5.5 0 0 0 7.5 7.5v-7A.5.5 0 0 0 7 0zm-.5 1v5.399l-2.17-1.9-.075-.054a.5.5 0 0 0-.584.054L1.5 6.398V1h5z" fill={color} fill-rule="nonzero"/>
        </svg>
    );
}

IconStory.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--teflon)"
};

export default IconStory;
